<template>
  <form :class="`ee-form ${size ? 'ee-form--' + size : ''}`">
    <slot></slot>
  </form>
</template>
<script>
  export default {
    compName: 'ee-form',
    props: {
      size: String,
      dataObject: Object,
      rules: Object
    },
    data () {
      return {
        fields: []
      }
    },
    created () {
      /**
       * 将 FormItem 里的数据项 添加到 form 的 fields里
       * 在FormItem 组件里触发事件
       */
      this.$on('ee.form.addField', field => {
        this.fields.push(field)
      })
      /**
       * 将数据项 从 form 的 fields 里移除
       */
      this.$on('ee.form.removeField', field => {
        const index = this.fields.indexOf(field)
        index >= 0 && this.fields.splice(index, 1)
      })
    },
    methods: {
      /**
       * 校验form表单里输入的数据是否合法
       * @returns {Promise} 返回promise对象
       */
      validate () {
        return Promise.all(this.fields.map(field => field.validate()))
          .catch(err => {
            console.error(err)
            return Promise.reject()
          })
      },
      /**
       * 校验form表单里输入的数据是否合法
       * @param fieldName 要校验的项
       * @returns {Promise} 返回promise对象
       */
      validateField (fieldName) {
        let f = null
        this.fields.every(field => {
          const t = field.prop !== fieldName
          !t && (f = field)
          return t
        })
        return f ? f.validate() : Promise.reject(`没找到需要校验的属性:${fieldName}`)
      }
    }
  }
</script>
<style src="../style/form.css"></style>


// WEBPACK FOOTER //
// src/packages/form/Form.vue?d9bc1ec8